exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".handsontable .htCore .ht_master .htCenter .htHeader{background-color:#f1f3f4;color:#202124;font-weight:700;border:1px solid #e0e0e0}.handsontable .htCore .ht_master .htCenter .htRowHeader{background-color:#e0e0e0;color:#202124;border-right:1px solid #e0e0e0}.handsontable .htCore .ht_master .htCenter .htColumnHeader{border-bottom:1px solid #bdbdbd}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-20bfddbc","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/common/Spreadsheet.vue
// module id = 1435
// module chunks = 0